import { Routes, Route, Navigate, useParams } from 'react-router-dom'
import Layout from './components/layout/Layout'
import ResourceDetail from './pages/ResourceDetail'
import ResourceLibrary from './pages/ResourceLibrary'
import EventsCalendar from './pages/EventsCalendar'
import OrbconReport from './pages/OrbconReport'
import EventDetail from './pages/EventDetail'
import Home from './pages/Home'
import GenericPage from './pages/GenericPage'
import NotFound from './pages/NotFound'
import SearchResults from './pages/SearchResults'
import Dashboard from './pages/Dashboard'
import Profile from './pages/Profile'
import Data from './pages/Data'
import Utilization from './pages/data/Utilization'
import SampleDataProject from './pages/data/SampleDataProject'
import DataEntry from './pages/data/DataEntry'
import SSOCallback from './pages/SSOCallback'
import ELearning from './pages/elearning/ELearning'
import Certifications from './pages/elearning/Certifications'
import CourseDetail from './pages/elearning/CourseDetail'
import ModuleViewer from './pages/elearning/ModuleViewer'
import CourseBuilder from './pages/elearning/admin/CourseBuilder'
import CourseList from './pages/elearning/admin/CourseList'
import ModuleEditor from './pages/elearning/admin/ModuleEditor'
import HubDetail from './pages/HubDetail'
import Programs from './pages/Programs'
import ProgramDetail from './pages/ProgramDetail'
import PlaceChild from './pages/PlaceChild'
import HubList from './pages/admin/hubs/HubList'
import HubEditor from './pages/admin/hubs/HubEditor'
import ProgramList from './pages/admin/programs/ProgramList'
import ProgramEditor from './pages/admin/programs/ProgramEditor'
import EventList from './pages/admin/events/EventList'
import EventEditor from './pages/admin/events/EventEditor'
import OrderResources from './pages/OrderResources'
import OrderList from './pages/admin/orders/OrderList'
import OrderDetail from './pages/admin/orders/OrderDetail'
import Careers from './pages/Careers'
import Glossary from './pages/Glossary'
import About from './pages/About'
import CardReview from './pages/design/CardReview'
import DiscoverabilityReview from './pages/design/DiscoverabilityReview'
import Contact from './pages/Contact'
import CareerList from './pages/admin/careers/CareerList'
import CareerEditor from './pages/admin/careers/CareerEditor'
import HospitalDomains from './pages/admin/HospitalDomains'
import ProtectedRoute from './components/auth/ProtectedRoute'
import ClerkApiAuthBinder from './components/auth/ClerkApiAuthBinder'

function LegacyAdminHubEditRedirect() {
  const { id } = useParams();
  return <Navigate to={`/admin/hubs/${id ?? ''}/edit`} replace />;
}

function App() {
  return (
    <Layout>
      <ClerkApiAuthBinder />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/resources" element={<Programs />} />
        <Route path="/resources/:slug" element={<ResourceDetail />} />
        <Route path="/library" element={<ResourceLibrary />} />
        <Route path="/toolkits/:slug" element={<HubDetail />} />
        <Route path="/references/glossary" element={<Glossary />} />
        <Route path="/references/:slug" element={<ProgramDetail />} />
        <Route path="/events" element={<EventsCalendar />} />
        <Route path="/report" element={<OrbconReport />} />
        <Route path="/events/:slug" element={<EventDetail />} />
        <Route path="/search" element={<SearchResults />} />
        <Route path="/sso-callback" element={<SSOCallback />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute requireSignIn>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute requireSignIn>
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/data"
          element={
            <ProtectedRoute requireData>
              <Data />
            </ProtectedRoute>
          }
        />
        <Route
          path="/data/utilization"
          element={
            <ProtectedRoute requireData>
              <Utilization />
            </ProtectedRoute>
          }
        />
        <Route
          path="/data/:projectSlug/entry"
          element={
            <ProtectedRoute requireDataEntry>
              <DataEntry />
            </ProtectedRoute>
          }
        />
        <Route
          path="/data/:projectSlug"
          element={
            <ProtectedRoute requireData>
              <SampleDataProject />
            </ProtectedRoute>
          }
        />
        <Route
          path="/elearning"
          element={
            <ProtectedRoute requireSignIn>
              <ELearning />
            </ProtectedRoute>
          }
        />
        <Route
          path="/elearning/certifications"
          element={
            <ProtectedRoute requireSignIn>
              <Certifications />
            </ProtectedRoute>
          }
        />
        <Route
          path="/elearning/courses/:slug"
          element={
            <ProtectedRoute requireSignIn>
              <CourseDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/elearning/courses/:courseSlug/modules/:moduleSlug"
          element={
            <ProtectedRoute requireSignIn>
              <ModuleViewer />
            </ProtectedRoute>
          }
        />
        <Route
          path="/elearning/admin/courses"
          element={
            <ProtectedRoute requireAdmin>
              <CourseList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/elearning/admin/courses/new"
          element={
            <ProtectedRoute requireAdmin>
              <CourseBuilder />
            </ProtectedRoute>
          }
        />
        <Route
          path="/elearning/admin/courses/:id/edit"
          element={
            <ProtectedRoute requireAdmin>
              <CourseBuilder />
            </ProtectedRoute>
          }
        />
        <Route
          path="/elearning/admin/courses/:courseId/modules/new"
          element={
            <ProtectedRoute requireAdmin>
              <ModuleEditor />
            </ProtectedRoute>
          }
        />
        <Route
          path="/elearning/admin/courses/:courseId/modules/:moduleId/edit"
          element={
            <ProtectedRoute requireAdmin>
              <ModuleEditor />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/hubs"
          element={
            <ProtectedRoute requireAdmin>
              <HubList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/hubs/new"
          element={
            <ProtectedRoute requireAdmin>
              <HubEditor />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/hubs/:id/edit"
          element={
            <ProtectedRoute requireAdmin>
              <HubEditor />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/programs"
          element={
            <ProtectedRoute requireAdmin>
              <ProgramList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/programs/new"
          element={
            <ProtectedRoute requireAdmin>
              <ProgramEditor />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/programs/:id/edit"
          element={
            <ProtectedRoute requireAdmin>
              <ProgramEditor />
            </ProtectedRoute>
          }
        />
        <Route path="/admin/toolkits" element={<Navigate to="/admin/hubs" replace />} />
        <Route path="/admin/toolkits/new" element={<Navigate to="/admin/hubs/new" replace />} />
        <Route path="/admin/toolkits/:id/edit" element={<LegacyAdminHubEditRedirect />} />
        <Route
          path="/admin/events"
          element={
            <ProtectedRoute requireAdmin>
              <EventList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/events/new"
          element={
            <ProtectedRoute requireAdmin>
              <EventEditor />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/events/:id/edit"
          element={
            <ProtectedRoute requireAdmin>
              <EventEditor />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/careers"
          element={
            <ProtectedRoute requireAdmin>
              <CareerList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/careers/new"
          element={
            <ProtectedRoute requireAdmin>
              <CareerEditor />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/careers/:id/edit"
          element={
            <ProtectedRoute requireAdmin>
              <CareerEditor />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/orders"
          element={
            <ProtectedRoute requireAdmin>
              <OrderList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/orders/:id"
          element={
            <ProtectedRoute requireAdmin>
              <OrderDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/hospital-domains"
          element={
            <ProtectedRoute requireAdmin>
              <HospitalDomains />
            </ProtectedRoute>
          }
        />
        <Route path="/design/cards" element={<CardReview />} />
        <Route path="/design/discoverability" element={<DiscoverabilityReview />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<GenericPage />} />
        <Route path="/terms" element={<GenericPage />} />
        <Route path="/useful-links" element={<GenericPage />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/order-resources" element={<OrderResources />} />
        <Route path="/page/:slug" element={<GenericPage />} />
        <Route path="/:subjectSlug/:childSlug" element={<PlaceChild />} />
        <Route path="/:slug" element={<ProgramDetail />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  )
}

export default App
